import { AllCardsType } from '../../../data/all-cards'
import { NombreTarotista } from '../../../data/personality'
import { DataTypePregunta } from '../../../interfaces/utils'
import { formatCardLabel } from '../../../utils/card-label'

export const interpret = (
    cards: AllCardsType[],
    data: DataTypePregunta,
    user: string,
    personality: NombreTarotista,
    type: string
) => {
    //console.log('Recibido en interpret:', data)
    const consult = `Quiero que interpretes una **Tirada de Autoconocimiento Profundo** con 10 cartas, ayudando al consultante ${
        data.consultante
    } a descubrir su verdadera esencia y su camino de crecimiento, ${
        data.consulta.length > 0
            ? 'ten en cuenta en la tirada la siguiente consulta que realiza el consultante: ' + data.consulta + ','
            : ''
    } según estas cartas: **¿Quién soy realmente?:** ${formatCardLabel(cards[0])}, **¿Qué imágen proyecto al mundo?:** ${formatCardLabel(cards[1])}, **Mi mayor fortaleza:** ${formatCardLabel(cards[2])}, **Mi mayor debilidad o sombra:** ${formatCardLabel(cards[3])}, **Patrón de autosabotaje:** ${formatCardLabel(cards[4])}, **Mensaje de mi subconsciente:** ${formatCardLabel(cards[5])}, **Lección de vida en este momento:** ${formatCardLabel(cards[6])} **Cómo alinear mi vida con mi verdadero ser:**: ${formatCardLabel(cards[7])} **Consejo espiritual o del universo:** ${formatCardLabel(cards[8])} y **Resultado si sigo el camino del autoconocimiento:** ${formatCardLabel(cards[9])}. Explica detalladamente cada carta y su significado en la posición donde ha salido. Detecta conexiones entre las cartas y patrones en la lectura. Proporciona consejos prácticos y reflexivos para ayudar al consultante en su camino de autoconocimiento. Si detectas bloqueos emocionales o creencias limitantes, sugiere herramientas de introspección y sanación.Mantén un tono profesional, empático y comprensible. Dirígete directamente al consultante, no utilices la tercera persona refiriendote a la consultante, aún cuando las consultas se encuentren en tercera persona, adapta la respuesta para que quede en segunda persona. Incluye además en 2 parrafos despues de la lectura, una respuesta directa para el consultante y un consejo final (extra-tarot).`

    let info = {
        consult,
        user,
        personality,
        clientName: data.consultante.name,
        clientPhone: data.consultante.phone || '',
        clientAnswer: data.consulta,
        cards,
        type,
    }

    return info
}
